/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import styled from 'styled-components';

export const StyledSubNav = styled.div`
  background: #fafafa;
  border-bottom: 1px solid #e9e9e9;
  position: sticky;
  top: 56px;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 998;
  overflow: hidden;
  padding: 0 46px;

  ul {
    display: flex;
    align-items: center;
    flex-flow: row nowrap;
    margin-left: 107px;
    list-style: none;
    margin: auto;
    li {
      margin-right: 20px;

      > a {
        display: inline-block;
        font-size: 14px;
        padding: 0 10px;
        color: #666;
        height: 35px;
        line-height: 35px;
        text-decoration: none;

        &:hover {
          color: #1283d5;
          border-bottom: 2px solid #1283d5;
        }

        &:focus {
          text-decoration: none;
        }
      }

      &.active {
        > a {
          color: #1283d5;
          border-bottom: 2px solid #1283d5;
        }
      }
    }
  }
`;
